const theme = {
  colors: {
    backgroundColor: '#121212',
    backgroundSecondary: '#0d0d0d',
    text: '#FFFFFF',
    textSecondary: '#a2a2a2',
    orange: '#FFB800',
    gray: '#BCBCBC',
    red: '#b03a3a',
    shimmerEffect: '#292929',
    gradients: {
      orangeToTransparent:
        'linear-gradient(180deg, rgba(255, 184, 0, 0.2) 0%, rgba(255, 184, 0, 0) 100%)',
    },
    transparentToBlack: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #121212 100%)`,
    blackToTransparent:
      'linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(13, 13, 13, 1) 100%)',
  },
};

export default theme;
